// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type SchemaTableQueriesQueryVariables = Types.Exact<{
  databaseId: Types.Scalars["ID"]["input"];
  tableId: Types.Scalars["ID"]["input"];
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
  offset?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  limit?: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
  filter?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortBy?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  sortDirection?: Types.InputMaybe<Types.SortDirection>;
}>;

export type SchemaTableQueriesQuery = {
  __typename?: "GraphqlQuery";
  getQueryStatsForTable?: Array<{
    __typename?: "QuerySummaryStats";
    id: string;
    normalizedQuery: string;
    truncatedQuery: string;
    avgTime: number;
    callsPerMinute: number;
    bufferHitRatio?: number | null;
    pctOfTotalIo?: number | null;
    pctOfTotal: number;
    postgresRoleCount: number;
    postgresRole?: {
      __typename?: "PostgresRole";
      id: string;
      name: string;
    } | null;
  }> | null;
  getServerDetails: { __typename?: "Server"; id: string; humanId: string };
};

export const SchemaTableQueriesDocument = gql`
  query SchemaTableQueries(
    $databaseId: ID!
    $tableId: ID!
    $startTs: Int!
    $endTs: Int!
    $offset: Int
    $limit: Int
    $filter: String
    $sortBy: String
    $sortDirection: SortDirection
  ) {
    getQueryStatsForTable(
      databaseId: $databaseId
      tableId: $tableId
      startTs: $startTs
      endTs: $endTs
      offset: $offset
      limit: $limit
      filter: $filter
      sortBy: $sortBy
      sortDirection: $sortDirection
    ) {
      id
      normalizedQuery
      truncatedQuery
      avgTime
      callsPerMinute
      bufferHitRatio
      pctOfTotalIo
      pctOfTotal
      postgresRole {
        id
        name
      }
      postgresRoleCount
    }
    getServerDetails(databaseId: $databaseId) {
      id
      humanId
    }
  }
`;

/**
 * __useSchemaTableQueriesQuery__
 *
 * To run a query within a React component, call `useSchemaTableQueriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchemaTableQueriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchemaTableQueriesQuery({
 *   variables: {
 *      databaseId: // value for 'databaseId'
 *      tableId: // value for 'tableId'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *      filter: // value for 'filter'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useSchemaTableQueriesQuery(
  baseOptions: Apollo.QueryHookOptions<
    SchemaTableQueriesQuery,
    SchemaTableQueriesQueryVariables
  > &
    (
      | { variables: SchemaTableQueriesQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    SchemaTableQueriesQuery,
    SchemaTableQueriesQueryVariables
  >(SchemaTableQueriesDocument, options);
}
export function useSchemaTableQueriesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    SchemaTableQueriesQuery,
    SchemaTableQueriesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    SchemaTableQueriesQuery,
    SchemaTableQueriesQueryVariables
  >(SchemaTableQueriesDocument, options);
}
// @ts-ignore
export function useSchemaTableQueriesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    SchemaTableQueriesQuery,
    SchemaTableQueriesQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableQueriesQuery,
  SchemaTableQueriesQueryVariables
>;
export function useSchemaTableQueriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableQueriesQuery,
        SchemaTableQueriesQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  SchemaTableQueriesQuery | undefined,
  SchemaTableQueriesQueryVariables
>;
export function useSchemaTableQueriesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        SchemaTableQueriesQuery,
        SchemaTableQueriesQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    SchemaTableQueriesQuery,
    SchemaTableQueriesQueryVariables
  >(SchemaTableQueriesDocument, options);
}
export type SchemaTableQueriesQueryHookResult = ReturnType<
  typeof useSchemaTableQueriesQuery
>;
export type SchemaTableQueriesLazyQueryHookResult = ReturnType<
  typeof useSchemaTableQueriesLazyQuery
>;
export type SchemaTableQueriesSuspenseQueryHookResult = ReturnType<
  typeof useSchemaTableQueriesSuspenseQuery
>;
export type SchemaTableQueriesQueryResult = Apollo.QueryResult<
  SchemaTableQueriesQuery,
  SchemaTableQueriesQueryVariables
>;
